import { EmailDispatchLogFilter } from '@tsin-core/services/http/email-tracking.service';

/** Load a page of the dispatch-log report. The supplied filter **replaces** the
 *  one held in state, so callers pass the complete filter (including page and
 *  limit) on every dispatch. Called with no argument it resets to defaults.
 *  Charger une page du rapport d'envois — le filtre fourni remplace celui du
 *  magasin. */
export class LoadEmailDispatchLogs {
  static readonly type = '[EmailTracking] Load Dispatch Logs';
  constructor(public filter: EmailDispatchLogFilter = {}) {}
}

/** Store the filter without triggering a request — used when the UI wants the
 *  filter persisted before an unrelated navigation.
 *  Enregistrer le filtre sans déclencher de requête. */
export class SetEmailDispatchLogFilter {
  static readonly type = '[EmailTracking] Set Dispatch Log Filter';
  constructor(public filter: EmailDispatchLogFilter) {}
}

/** Load one dispatch with its recipients / Charger un envoi et ses destinataires */
export class LoadEmailDispatchLog {
  static readonly type = '[EmailTracking] Load Dispatch Log';
  constructor(public id: string) {}
}

/** Drop the open dispatch detail / Fermer le détail d'envoi ouvert */
export class ClearSelectedEmailDispatchLog {
  static readonly type = '[EmailTracking] Clear Selected Dispatch Log';
}

/** Reset the whole email-tracking slice / Réinitialiser l'état de suivi */
export class ClearEmailDispatchLogs {
  static readonly type = '[EmailTracking] Clear Dispatch Logs';
}
